export default __webpack_public_path__ + "static/p8-e821c702d4db6f2beb7c8d65f6c4d20a.png";